// All Tu list pages include a default NOINDEX meta tag in their header.
// This is a list of Tu pages for which the NOINDEX tag has been intentionally removed.
// Add the page's path to the array `tuPages` to remove the NOINDEX meta tag from the header.
export const tuPages = [
  '/list/shop-branded-clothing-sale/',
  '/list/shop-for-baby-tu-clothing-sale/',
  '/list/shop-for-kids-tu-clothing-sale/',
  '/list/shop-for-womens-tu-clothing-sale/',
  '/list/shop-mens-tu-clothing-sale/',
  '/list/shop-for-lingerie-tu-clothing-sale/'
]
